import { gql } from "@apollo/client";
import { getArrayObjectWithoutTypeName } from "../../../../utils/convert";

export const GET_REQUISITO_CLIENTE_BY_COD_SAP = gql`
query requisitoClienteByCodSap($codSap: String!) {
    requisitoClienteByCodSap(codSap: $codSap)
    {
        idRequisitoCliente 
        cod_Sap
        mail 
        pers_Contacto 
        idTmpFact 
        dia_Inicio_Fact_Mensual 
        dia_Fin_Fact_Mensual 
        autorizaciones
        conformidades 
        enfermeria 
        remito_NH 
        iDTipoRemitoNH 
        remito_FK 
        iDTipoRemitoFK 
        prescripcion 
        validacion 
        documentacion_Pac 
        observaciones 
        fA 
        enfermeriaGuardia 
        nutricionista 
        fonoaudiologo 
        psicologo 
        kinesiologo 
        tocupacional 
        asocial 
        psiquiatra 
        cargo 
        telefono 
        docRespaldatoria 
        presentacionFact 
        mailFact 
        idTipoAutorizacion 
        minuta_DNI 
        minuta_nombreApellido 
        minuta_nroAfiliado 
        minuta_nroOC 
        minuta_nroRemito 
        editaFechaHasta 
        aprobacionMasiva 
        bloqueoPaciente 
        bloqueoProrroga 
        bloqueoCotizar 
        bloqueoEnvio 
        subVentas 
        telemedicina 
        evolucionMedica
        t_RequisitoTipoModulo{
            idRequisitoTipoModulo
            idTipoModulo
            idRequisito
        }
    }
}`;

export const requisitoClienteAdapter = (requisitoCliente) => ({
  ...requisitoCliente,
  bloqueoPaciente: Boolean(requisitoCliente?.bloqueoPaciente),
  bloqueoProrroga: Boolean(requisitoCliente?.bloqueoProrroga),
  bloqueoCotizar: Boolean(requisitoCliente?.bloqueoCotizar),
  bloqueoEnvio: Boolean(requisitoCliente?.bloqueoEnvio),
  idTmpFact: requisitoCliente?.idTmpFact?.toString() || '',
  presentacionFact: requisitoCliente?.presentacionFact?.toString() || '',
  docRespaldatoria: requisitoCliente?.docRespaldatoria?.toString() || '',
  idTipoAutorizacion: requisitoCliente?.idTipoAutorizacion?.toString() || '',
  t_RequisitoTipoModulo: !!requisitoCliente?.t_RequisitoTipoModulo && requisitoCliente?.t_RequisitoTipoModulo?.length > 0 ?
  getArrayObjectWithoutTypeName(requisitoCliente?.t_RequisitoTipoModulo) : []
});